import React from 'react';

const EventsModal = ({
  matches, leagues, getDate, getTime,
}) => (
  <table className="event-selection">
    <thead>
      <tr>
        <th>Date</th>
        <th>Team Home</th>
        <th>Team Away</th>
        <th>Championship</th>
        <th>Season</th>
        <th>Round</th>
      </tr>
    </thead>
    <tbody>
      {matches.map((event) => (
        <tr key={event.matchId}>
          <td>
            {getDate(event.startDateTime)}
            <span className="m-l-10">{getTime(event.dateTime)}</span>
          </td>
          <td>{event.teamHome.name}</td>
          <td>{event.teamAway.name}</td>
          <td>{leagues?.find((l) => l.id === event.leagueId)?.name}</td>
          <td>{event.season}</td>
          <td>{event.round}</td>
        </tr>
      ))}

    </tbody>
  </table>
);

export default EventsModal;
